<template>
  <div class="goal-gambit-frame">
    <iframe
      v-if="migrationReady"
      :src="gameUrl"
      class="goal-gambit-iframe"
      title="Goal Gambit"
      frameborder="0"
      allow="autoplay; fullscreen; gyroscope; accelerometer; clipboard-write; encrypted-media"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "GoalGambitGame",
  data() {
    return {
      migrationReady: false,
    };
  },
  async mounted() {
    if (!("serviceWorker" in navigator)) {
      console.error("Goal Gambit migration worker is not supported");
      return;
    }

    try {
      await navigator.serviceWorker.register("/goal-gambit-migration-sw.js", {
        scope: "/",
      });

      if (navigator.serviceWorker.controller) {
        this.migrationReady = true;
        return;
      }

      navigator.serviceWorker.addEventListener(
        "controllerchange",
        () => window.location.reload(),
        { once: true }
      );
    } catch (error) {
      console.error("Goal Gambit migration worker registration failed", error);
    }
  },
  computed: {
    // Self-hosted Unity WebGL build in /public/goal-gambit.
    // The router guard guarantees we only reach this view with an ?msisdn=
    // param, so we forward it straight into the game (the game's index.html
    // also gates on it as a fallback).
    gameUrl() {
      const msisdn = new URLSearchParams(window.location.search).get("msisdn") || "";
      const base = `${process.env.BASE_URL}game/index.html`;
      return msisdn ? `${base}?msisdn=${encodeURIComponent(msisdn)}` : base;
    },
  },
};
</script>

<style scoped>
.goal-gambit-frame {
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  background: #000;
}

.goal-gambit-iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
